import { useEffect, useState, useRef } from 'react';
import { GoogleMap, useGoogleMap } from '@react-google-maps/api';
import { Box, useTheme } from '@mui/material';
import EditPolygon from './EditPolygon/EditPolygon';
import { ReturnToBoundsButton } from './ReturnToBoundsButton';

const center = { lat: 31.794431983241022, lng: 35.18878195954886 };

const MyMap = ({ polygon }: { polygon: any }) => {
  const containerStyle = {
    height: '100%',
    width: '100%',
    borderRadius: '8px'
  };

  return (
    <Box sx={{ position: 'relative', height: '100%', width: '100%' }}>
      <GoogleMap zoom={8} center={center} mapContainerStyle={containerStyle}>
        <PolygonWithBounds polygon={polygon} />
        <EditPolygon />
      </GoogleMap>
    </Box>
  );
};

export const PolygonWithBounds = ({ polygon, autoFit = true }: { polygon: any; autoFit?: boolean }) => {
  const map = useGoogleMap();
  const theme = useTheme();
  const [bounds, setBounds] = useState<google.maps.LatLngBounds | null>(null);
  const polygonRef = useRef<google.maps.Polygon | null>(null);

  useEffect(() => {
    // Clean up previous polygon if exists
    if (polygonRef.current) {
      polygonRef.current.setMap(null);
      polygonRef.current = null;
    }

    if (map && polygon) {
      const newBounds = new google.maps.LatLngBounds();
      const paths: google.maps.LatLng[][] = [];

      polygon?.geom?.coordinates?.forEach((coordinate: any) => {
        const mvc: google.maps.LatLng[] = [];
        coordinate[0]?.forEach((point: any) => {
          const latLng = new google.maps.LatLng({ lat: point[1], lng: point[0] });
          mvc.push(latLng);
          newBounds.extend(latLng);
        });
        paths.push(mvc);
      });

      const area = new google.maps.Polygon({
        paths,
        strokeColor: `${theme.palette.primary.main}`,
        strokeOpacity: 1,
        strokeWeight: 3.5,
        fillColor: '#e7eaed',
        fillOpacity: 0.4
      });

      area.setMap(map);
      polygonRef.current = area;

      // Only auto-fit bounds if autoFit is true (default behavior)
      if (autoFit) {
        map.fitBounds(newBounds);
      }

      setBounds(newBounds);
    }

    // Cleanup function
    return () => {
      if (polygonRef.current) {
        polygonRef.current.setMap(null);
        polygonRef.current = null;
      }
    };
  }, [map, polygon, autoFit, theme.palette.primary.main]);

  return <ReturnToBoundsButton bounds={bounds} enabled={!!polygon} />;
};

export default MyMap;
